import { renderless, api } from "@opentiny/vue-renderless/checkbox/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { iconHalfselect, iconCheckedSur, iconCheck } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  inheritAttrs: false,
  emits: ["update:modelValue", "change", "complete"],
  props: [].concat(props, ["modelValue", "text", "events", "label", "indeterminate", "disabled", "checked", "name", "trueLabel", "falseLabel", "id", "controls", "size", "border", "validateEvent", "customClass", "displayOnly"]),
  components: {
    IconHalfselect: iconHalfselect(),
    IconCheckedSur: iconCheckedSur(),
    IconCheck: iconCheck()
  },
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", _vm._b({
    class: _vm.m("inline-flex sm:items-center text-sm leading-5 cursor-pointer", _vm.state.size === "medium" ? "sm:text-sm" : "sm:text-xs", {
      "sm:py-2": _vm.state.vertical
    }, _vm.state.isDisplayOnly || _vm.state.isGroupDisplayOnly ? _vm.state.isChecked ? "cursor-default after:content-[';'] after:inline-block last:after:content-['']" : "hidden" : "", _vm.state.showLabel ? "inline-flex" : "", _vm.customClass),
    attrs: {
      "data-tag": "tiny-checkbox",
      "id": _vm.id,
      "tabindex": "-1"
    }
  }, "label", _vm.a(_vm.$attrs, ["class", "style", "onClick"], true), false), [_c("span", {
    class: ["relative", _vm.state.size === "medium" ? "sm:w-6 sm:h-6" : "sm:h-4 sm:w-4", _vm.state.isDisplayOnly || _vm.state.isGroupDisplayOnly ? "hidden" : ""],
    attrs: {
      "role": _vm.indeterminate ? "checkbox" : false,
      "aria-checked": _vm.indeterminate ? "mixed" : false
    }
  }, [_c("span", {
    staticClass: "inline-flex p-3 sm:p-0",
    attrs: {
      "tabindex": "1"
    }
  }, [!_vm.state.isChecked && !_vm.indeterminate ? _c("icon-check", {
    class: [_vm.state.isDisabled ? "[&_path:nth-of-type(2)]:fill-color-icon-disabled [&_path:nth-of-type(1)]:fill-color-bg-3 cursor-not-allowed" : "[&_path:nth-of-type(1)]:fill-color-icon-inverse [&_path:nth-of-type(2)]:fill-color-none-hover"],
    attrs: {
      "data-tag": "icon-check",
      "custom-class": ["w-5 h-5 flex-1", _vm.state.size === "medium" ? "sm:w-6 sm:h-6" : "sm:w-4 sm:h-4"]
    }
  }) : _vm.indeterminate ? _c("icon-halfselect", {
    attrs: {
      "data-tag": "icon-halfselect",
      "custom-class": _vm.m("w-5 h-5 flex-1 [&_path:nth-of-type(2)]:fill-color-icon-inverse", _vm.state.isDisabled ? "[&_path:nth-of-type(1)]:fill-color-brand-disabled cursor-not-allowed" : "[&_path:nth-of-type(1)]:fill-color-brand", _vm.state.size === "medium" ? "sm:w-6 sm:h-6" : "sm:w-4 sm:h-4")
    }
  }) : _vm.state.isChecked ? _c("icon-checked-sur", {
    class: _vm.m("flex-1 [&_path:nth-of-type(2)]:fill-color-icon-inverse", _vm.state.isDisabled ? "[&_path:nth-of-type(1)]:fill-color-brand-disabled cursor-not-allowed" : "[&_path:nth-of-type(1)]:fill-color-brand"),
    attrs: {
      "data-tag": "icon-checked-sur",
      "custom-class": ["w-5 h-5", _vm.state.size === "medium" ? "sm:w-6 sm:h-6" : "sm:w-4 sm:h-4"]
    }
  }) : _vm._e()], 1), _vm.trueLabel || _vm.falseLabel ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.state.model,
      expression: "state.model"
    }],
    staticClass: "absolute left-0 right-0 top-0 bottom-0 w-0 h-0 -z-10 opacity-0",
    attrs: {
      "type": "checkbox",
      "aria-hidden": _vm.indeterminate ? "true" : "false",
      "name": _vm.name,
      "disabled": _vm.state.inputDisabled,
      "true-value": _vm.trueLabel,
      "false-value": _vm.falseLabel
    },
    domProps: {
      "checked": Array.isArray(_vm.state.model) ? _vm._i(_vm.state.model, null) > -1 : _vm._q(_vm.state.model, _vm.trueLabel)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.state.model, $$el = $event.target, $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel;
        if (Array.isArray($$a)) {
          var $$v = null, $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.state, "model", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.state, "model", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.state, "model", $$c);
        }
      }, _vm.handleChange],
      "focus": function focus($event) {
        _vm.state.focus = true;
      },
      "blur": function blur($event) {
        _vm.state.focus = false;
      },
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }) : _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.state.model,
      expression: "state.model"
    }],
    staticClass: "absolute left-0 right-0 top-0 bottom-0 w-0 h-0 -z-10 opacity-0",
    attrs: {
      "type": "checkbox",
      "aria-hidden": _vm.indeterminate ? "true" : "false",
      "disabled": _vm.state.inputDisabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.label,
      "checked": Array.isArray(_vm.state.model) ? _vm._i(_vm.state.model, _vm.label) > -1 : _vm.state.model
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.state.model, $$el = $event.target, $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.label, $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.state, "model", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.state, "model", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.state, "model", $$c);
        }
      }, _vm.handleChange],
      "focus": function focus($event) {
        _vm.state.focus = true;
      },
      "blur": function blur($event) {
        _vm.state.focus = false;
      },
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm.slots.default && _vm.slots.default() || _vm.state.isShowText ? _c("span", {
    ref: "label",
    class: _vm.m("py-3 sm:py-0 pl-0 sm:pl-2 mr-5 flex-auto", _vm.state.isDisabled ? "cursor-not-allowed text-color-text-disabled" : "text-color-text-primary", _vm.state.isDisplayOnly || _vm.state.isGroupDisplayOnly ? "p-0 sm:p-0 m-0 text-color-text-primary cursor-default" : "")
  }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.state.showText))];
  })], 2) : [_vm.state.isDisplayOnly ? _c("span", {
    staticClass: "text-color-text-primary cursor-default"
  }, [_vm._v(" " + _vm._s(_vm.state.displayLabel))]) : _vm._e()]], 2);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
